import React, {useState}from 'react'
import styles from "./LeadGeneration.module.css"
import illustration from '../../Images/Leadgenerationimage.png'
import { CheckCircle } from "lucide-react"; 
import { Sparkles, TrendingUp, Clock, DollarSign, BarChart } from "lucide-react";
const LeadGeneration = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const faqs = [
    {
      question: "Can AI send personalized messages?",
      answer:
        "Yes, every message is automatically personalized based on candidate data and job role.",
    },
    {
      question: "How do follow-ups work?",
      answer:
        "AI sends automated reminders to unresponsive prospects with customizable sequences.",
    },
  
    {
      question: "Does it integrate with ATS and LinkedIn?",
      answer:
        "Absolutely, it supports major CRM platforms and LinkedIn integration for seamless workflow.",
    },
    {
      question: "Is lead data secure?",
      answer:
        "Yes, with enterprise-grade encryption and full compliance with data privacy regulations.",
    }
    
  ];


  const steps = [
    {
      number: "01",
      title: "Prospect Identification",
      text: "Import contacts from CRM, LinkedIn, or CSV. AI scans profiles, identifies buying signals, and scores leads.",
    },
    {
      number: "02",
      title: "AI-Powered Personalization",
      text: "Craft custom messages for each prospect. Adjust tone for industry, role, and company size.",
    },
    {
      number: "03",
      title: "Automated Campaign Scheduling",
      text: "Send messages via email, LinkedIn, SMS, or WhatsApp. Schedule for peak engagement times.",
    },
    {
      number: "04",
      title: "Engagement Tracking & Analytics",
      text: "Monitor opens, clicks, replies, and response times. Dashboard highlights hot leads ready for follow-up.",
    },
    {
      number: "05",
      title: "Lead Nurturing Automation",
      text: "AI automatically follows up with unresponsive leads. Customizable sequence and messaging style.",
    },
  ];
  const features = [
    "Smart Lead Scoring: Prioritize leads with the highest potential",
    "Personalized Outreach: Tailored messages for each prospect",
    "Multi-Channel Engagement: Email, LinkedIn, SMS, WhatsApp",
    "Automated Follow-Ups: Nurture leads automatically",
    "Seamless CRM Integration: Salesforce, HubSpot, Zoho, Pipedrive",
    "Analytics & Reporting: Track campaign performance and ROI",
  ];

 const benefits = [
    {
      title: "Time-Saving Benefits",
      text: "Automate lead research and outreach. Save 50–70% of manual prospecting time."
    },
    {
      title: "Improved Lead Quality",
      text: "Focus on high-intent prospects. Reduce wasted effort on low-quality leads."
    },
    {
      title: "Data-Driven Insights",
      text: "AI identifies top-performing messaging strategies. Optimize campaigns for better ROI."
    },
    {
      title: "Faster Sales Cycle",
      text: "Automated nurturing accelerates deals. Engage more leads faster."
    },
    {
      title: "Cost Efficiency",
      text: "Reduce dependency on outsourced lead generation. Streamline internal sales operations."
    }
  ];


   const items = [
    {
      title: "Time-Saving Benefits",
      text: "Automate lead research and outreach. Save 50–70% of manual prospecting time."
    },
    {
      title: "Improved Lead Quality",
      text: "Focus on high-intent prospects. Reduce wasted effort on low-quality leads."
    },
    {
      title: "Data-Driven Insights",
      text: "AI identifies top-performing messaging strategies. Optimize campaigns for better ROI."
    },
    {
      title: "Faster Sales Cycle",
      text: "Automated nurturing accelerates deals. Engage more leads faster."
    },
    {
      title: "Cost Efficiency",
      text: "Reduce dependency on outsourced lead generation. Streamline internal sales operations."
    }
  ];

  
  return (
    <>

   {/* Hero Section */}
   <section className={styles.hero}>
        <div className={styles.imageWrapper}>
          <img src={illustration} className={styles.image}></img>

          <div className={styles.textOverlay}>
            <h1 className={styles.headline}>AI Lead Generation</h1>
            <p className={styles.subheadline}>
              Generate leads faster with <span> AI Lead Agent </span> AI Lead
              Agent. Automate prospecting, personalize outreach, track
              engagement, and grow your sales pipeline efficiently.
            </p>
          </div>
        </div>
      </section>
  
{/* Second Section */}
    <section className={styles.section}>
      <div className={styles.content}>
        <h1 className={styles.secondheadline}>
          AI Lead Agent – <span className={styles.accent}>Supercharge Your Lead Generation</span>
        </h1>
        <p className={styles.secondsubheadline}>
          Automate prospecting, generate high-quality leads, and boost conversions with 
          AI-driven campaigns. Transform your sales pipeline today.
        </p>
        <button className={styles.cta}> Start Generating Leads Smarter</button>
      </div>
    </section>



{/* Third Section */}


<section className={styles.thirdsection}>
      <div className={styles.thirdcontent}>
        <h2 className={styles.thirdheadline}>
          Struggling to Find High-Quality Leads? <span>AI Can Help</span>
        </h2>
        <p className={styles.thirdtext}>
          Sales teams often waste hours on manual prospecting, cold outreach, and
          tracking leads that never respond. <strong>AI Lead Agent</strong> streamlines this process by
          automatically identifying prospects, personalizing outreach, and
          nurturing leads through the sales funnel.
        </p>

        <div className={styles.thirdcards}>
          <div className={styles.thirdcard}>
            <h3 className={styles.thirdcardNumber}>60%</h3>
            <p className={styles.thirdcardText}>
              Sales reps spend up to 60% of their time on lead generation
            </p>
          </div>

          <div className={styles.thirdcard}>
            <h3 className={styles.thirdcardNumber}>3x</h3>
            <p className={styles.thirdcardText}>
              Personalized outreach increases response rates by 3x
            </p>
          </div>

          <div className={styles.thirdcard}>
            <h3 className={styles.thirdcardNumber}>50%</h3>
            <p className={styles.thirdcardText}>
              AI-assisted campaigns can boost qualified leads by up to 50%
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* Fourth Section */}

<section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.headline}>
          How <span>AI Lead Agent</span> Generates High-Quality Leads – Step by Step
        </h2>

        <div className={styles.timeline}>
          {steps.map((step, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.number}>{step.number}</div>
              <div>
                <h3 className={styles.title}>{step.title}</h3>
                <p className={styles.text}>{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Fifth Section */}
    <section className={styles.fifthsection}>
      <div className={styles.fifthcontainer}>
        <h2 className={styles.fifthheadline}>
          Powerful Features for <span>Maximum Lead Conversion</span>
        </h2>
        

        <div className={styles.fifthgrid}>
          {features.map((feature, index) => (
            <div key={index} className={styles.fifthcard}>
              <div className={styles.fifthiconWrapper}>
                <CheckCircle size={26} />
              </div>
              <p className={styles.fifthfeature}>{feature}</p>
            </div>
          ))}
        </div>
      </div>
    </section>


    {/* sixth section */}
    <section className={styles.sixsection}>
  <div className={styles.sixcontainer}>
    <h2 className={styles.sixheadline}>
      Transform Your Sales <span> Process </span> with AI
    </h2>

    <div className={styles.sixgrid}>
      {benefits.map((benefit, index) => (
        <div key={index} className={styles.sixcard}>
          <h3 className={styles.sixtitle}>{benefit.title}</h3>
          <p className={styles.sixtext}>{benefit.text}</p>
        </div>
      ))}
    </div>
  </div>
</section>


    {/* Seventh */}
<section className={styles.sevensection}>
  <div className={styles.sevencontainer}>
    <h2 className={styles.sevenheadline}>
      Seamless Integration with <span>Your Sales Stack</span>
    </h2>

    <div className={styles.sevengrid}>
      {["Auto-sync lead lists", "Real-time updates for engagement tracking", "Multi-channel automation"].map((item, index) => (
        <div key={index} className={styles.sevencard}>
          <h3 className={styles.seventitle}>{item}</h3>
        </div>
      ))}
    </div>

    <button className={styles.sevenbutton}>Integrate with Your CRM Now</button>
  </div>
</section>


{/* Eight Section */}

{/* Eight Section */}
{/* Eight Section */}
<section className={styles.eightsection}>
  <div className={styles.eightcontainer}>
    <h2 className={styles.eightheadline}>
      Trusted by <span>Sales Teams Worldwide</span>
    </h2>

    <div className={styles.eightgrid}>
      <div className={styles.eightcard}>
        <p className={styles.eightquote}>
          “AI Lead Agent transformed our prospecting process. Response rates doubled within weeks.”
        </p>
        <p className={styles.eightauthor}>— Sales Director, TechSolutions</p>
      </div>

      <div className={styles.eightcard}>
        <p className={styles.eightquote}>
          “We saw a 3x increase in qualified leads without hiring additional reps.”
        </p>
        <p className={styles.eightauthor}>— VP of Sales, FinTechCo</p>
      </div>
    </div>
  </div>
</section>

        
{/* faq */}
    <section className={styles.faqSection} id="faq">
        <h2 className={styles.faqHeadline}>Frequently Asked Questions</h2>
        <div className={styles.faqList}>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`${styles.faqItem} ${
                activeIndex === index ? styles.active : ""
              }`}
            >
              <button
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                <span>{activeIndex === index ? "−" : "+"}</span>
              </button>
              {activeIndex === index && (
                <div className={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </section>



      
{/* Ten Section */}
<section className={styles.tensection}>
  <div className={styles.tencontainer}>
    {/* Left side - Heading */}
    <h2 className={styles.tenheadline}>
      Flexible Plans for <span>Every Sales Team</span>
    </h2>

    {/* Right side - Content + Button */}
    <div>
      <p className={styles.tencontent}>
        Start Generating Leads Smarter with AI Today. Stop wasting hours on
        manual prospecting — let <strong>AI Lead Agent</strong> automate your
        outreach, nurture leads, and grow your pipeline. Close more deals faster
        with smarter lead generation.
      </p>
      <button className={styles.tenbutton}>Get Started Now</button>
    </div>
  </div>
</section>



      </>
    
  )
}

export default LeadGeneration;


